// @ts-check
import React from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import HForm, {
  RadioGroupField,
  TextAreaField,
} from 'shared/containers/portal_layout/HForm';
import SpinnerButton from 'shared/components/SpinnerButton';
import componentForQuestion from './componentForQuestion';
import QuestionnaireFormManager from 'shared/components/QuestionnaireFormManager/QuestionnaireFormManager';
import { cleanCamelHash } from 'utils/questionnaireUtils';
import { useReferralSettings } from '../NewReferralProfileForm/useReferralSettings';
import LoadingContent from 'shared/components/LoadingContent';

/** @typedef {{
  questionnaire: any,
  referralProfile: {
    stat: boolean;
    networkOrganizationId?: string;
  };
  rulableReferralProfileValues: any,
  saveQuestionnaire: any
}} QuestionnaireFormPropsType */

/** @type { React.FC<QuestionnaireFormPropsType> } */
const QuestionnaireForm = (props) => {
  const {
    questionnaire,
    referralProfile,
    rulableReferralProfileValues,
    saveQuestionnaire,
  } = props;

  const referralSettingsQuery = useReferralSettings(
    referralProfile.networkOrganizationId
  );

  if (!referralSettingsQuery.isFetched) {
    return <LoadingContent />;
  }

  return (
    <QuestionnaireFormManager
      form="referralQuestionnaire"
      questionnaire={questionnaire}
      referralProfile={referralProfile}
      rulableReferralProfileValues={rulableReferralProfileValues}
      saveQuestionnaire={saveQuestionnaire}
      render={({ visibleQuestionnaire, handleSubmit, submitting }) => (
        <HForm onSubmit={handleSubmit}>
          <div
            className={
              !referralSettingsQuery.data.referralSettings.askForUrgency
                ? 'is-hidden'
                : ''
            }
          >
            <div className="referral-questionnaire-section-title">
              <h4 className="p-6 text-lg font-semibold">Urgency</h4>
            </div>
            <RadioGroupField
              name="referralProfile.stat"
              label="Referral Urgency"
              options={[
                { label: 'Routine', value: false },
                { label: 'STAT', value: true },
              ]}
            />
          </div>
          {visibleQuestionnaire.sections.map((section) => (
            <div key={section.title}>
              <div className="referral-questionnaire-section-title">
                <h4 className="p-6 text-lg font-semibold">{section.title}</h4>
              </div>
              {section.questions.map((question) =>
                componentForQuestion(section.title, question)
              )}
              {!section.suppressNotes && (
                <TextAreaField
                  name={`${cleanCamelHash(section.title)}__notes`}
                  label="Notes"
                />
              )}
            </div>
          ))}

          <div className="form-actions">
            <SpinnerButton
              type="submit"
              className="btn btn-primary"
              loading={submitting}
            >
              Continue
            </SpinnerButton>
          </div>
        </HForm>
      )}
    />
  );
};

QuestionnaireForm.displayName = 'QuestionnaireForm';

QuestionnaireForm.propTypes = {
  questionnaire: PropTypes.object.isRequired,
  referralProfile: PropTypes.object.isRequired,
  rulableReferralProfileValues: PropTypes.object.isRequired,
  saveQuestionnaire: PropTypes.func.isRequired,
};

export default QuestionnaireForm;
